import { render } from "./videoDetail.vue?vue&type=template&id=dc2b5d12&scoped=true"
import script from "./videoDetail.vue?vue&type=script&lang=js"
export * from "./videoDetail.vue?vue&type=script&lang=js"

import "./videoDetail.vue?vue&type=style&index=0&id=dc2b5d12&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc2b5d12"]])

export default __exports__